'use client';

import * as React from 'react';
import { mergeProps } from '../../merge-props/index.js';
import { useForkRef } from '../../utils/useForkRef.js';
import { useButton } from '../../use-button/index.js';
export function useCollapsibleTrigger(parameters) {
  const {
    panelId,
    disabled,
    open,
    rootRef: externalRef,
    handleTrigger
  } = parameters;
  const {
    getButtonProps,
    buttonRef
  } = useButton({
    disabled,
    focusableWhenDisabled: true
  });
  const handleRef = useForkRef(externalRef, buttonRef);
  const getRootProps = React.useCallback((externalProps = {}) => mergeProps({
    'aria-controls': panelId,
    'aria-expanded': open,
    disabled,
    onClick: handleTrigger,
    ref: handleRef
  }, externalProps, getButtonProps), [panelId, disabled, getButtonProps, handleRef, open, handleTrigger]);
  return {
    getRootProps
  };
}